/**
 * "Edit mission" in the mission detail's Operations Planning card (PR6 UX). Always shown: neutral
 * outline when the stored take-off point / flight area are fine, the warning variant when they need
 * completing (`needsFix`, see lib/flightArea.js storedFlightAreaNeedsFix).
 */
import { Pencil } from 'lucide-react';
import { Button } from '../ui/button';

const WARNING_CLASS = 'border-[var(--status-warning)] text-[var(--status-warning)] hover:bg-[var(--status-warning)]/10';

export const OperationsPlanningEditButton = ({ needsFix = false, onClick, label }) => (
  <Button
    type="button"
    variant="outline"
    size="sm"
    className={`gap-1.5 h-8 ${needsFix ? WARNING_CLASS : ''}`.trim()}
    onClick={onClick}
    data-testid={needsFix ? 'complete-flight-area-btn' : 'edit-mission-planning-btn'}
    data-variant={needsFix ? 'warning' : 'neutral'}
  >
    <Pencil className="h-3.5 w-3.5" />
    {label}
  </Button>
);

export default OperationsPlanningEditButton;
